export const createMap = (iterable) => new Map(iterable);
export const getFromMap = (map, key) => map.get(key);
export const putOnMap = (map, key, value) => (map.set(key, value), value);
export const existsOnMap = (map, key) => map.has(key);
export const deleteFromMap = (map, key) => map.delete(key);
export const clearMap = (map) => map.clear();
export const getValuesOfMap = (map) => map.values();
export const getKeysOfMap = (map) => map.keys();
export const sizeOfMap = (map) => map.size;
export const forEachOfMap = (map, callbackFn) => map.forEach(callbackFn);
export const cacheWithMap = (map, key, callback) => getFromMap(map, key) ?? putOnMap(map, key, callback());
